/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_CreateInputs */

const es_feedback_create = /** @type {(inputs: Feedback_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear Feedback`)
};

const en_feedback_create = /** @type {(inputs: Feedback_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Feedback`)
};

/**
* | output |
* | --- |
* | "Create Feedback" |
*
* @param {Feedback_CreateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_create = /** @type {((inputs?: Feedback_CreateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_CreateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_create(inputs)
	return en_feedback_create(inputs)
});
export { feedback_create as "feedback.create" }